<div
  class="flex h-full w-16 flex-col items-center justify-between bg-white pt-6 pb-4 shadow-md shadow-zinc-400"
>
  <div class="flex flex-col gap-2">
    @for (item of topTabs(); track item.label) {
      <p-button
        styleClass="border-none hover:!shadow-zinc-400 hover:!shadow-md"
        [routerLink]="item.route"
        variant="text"
        routerLinkActive="active hover:!shadow-none"
        [pTooltip]="item.label"
      >
        <fa-icon
          [icon]="item.icon | icon"
          class="text-zinc-600"
          size="lg"
          routerLinkActive="!text-primary"
        />
      </p-button>
    }
  </div>

  @for (item of bottomTabs(); track item.label) {
    <p-button
      styleClass="!bg-zinc-600 !text-white w-10 h-10 !shadow-zinc-400 !shadow-md hover:!shadow-zinc-600"
      rounded
      raised
      [routerLink]="item.route"
      variant="text"
      routerLinkActive="active"
      [pTooltip]="item.label"
    >
      <fa-icon
        [icon]="item.icon | icon"
        size="lg"
        routerLinkActive="!text-primary-blue-50"
      />
    </p-button>
  }
</div>
